import { render } from "./AlbenScreen.vue?vue&type=template&id=314a3fbc&scoped=true"
import script from "./AlbenScreen.vue?vue&type=script&lang=js"
export * from "./AlbenScreen.vue?vue&type=script&lang=js"

import "./AlbenScreen.vue?vue&type=style&index=0&id=314a3fbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314a3fbc"]])

export default __exports__